import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { colors, typography } from '../../../styles';
import ButtonSet from '../../ButtonSet';

const styles = css`
  margin: 15px 0;
  @media (min-width: 992px) {
    margin: 60px 0 90px 0;
  }
  @media (min-width: 992px) {
    margin: -60px 0 90px 0;
  }
  .IconCardBanner {
    padding: 90px 0 30px 0;
    margin: 0 auto;
    position: relative;
    width: 100%;
    max-width: 2000px;
    @media (min-width: 992px) {
      padding: 120px 0 0 0;
    }
  }
  .IconCardBanner_inner {
  }
  .IconCardBanner_heading {
    text-align: center;
    position: relative;
    z-index: 3;
    max-width: 1500px;
    margin: 0 auto 75px auto;
  }
  .IconCardBanner_headline {
    font-size: 30px;
    line-height: 1.2;
    font-family: ${typography.Serif};
    color: ${colors.white};
    font-weight: 600;
    display: block;
    text-align: center;
    @media (min-width: 992px) {
      font-size: 50px;
    }
  }
  .IconCardBanner_cardWrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 auto;
    width: 100%;
  }
  .IconCardBanner_card {
    width: 100%;
    background-color: #254716;
    padding: 0 30px 0px 30px;
    background: linear-gradient(145.72deg, #5CB2C1 0%, #22517E 100%);
    @media (min-width: 1200px) {
      width: 33.333%;
      padding: 0 60px 45px 60px;
    }
    &:nth-child(2) {
      background-color: #1A3A0E;
    }
    &:nth-child(3) {
      background-color: #122A08
    }
  }
  .IconCardBanner_cardIcon {
    height: 183px;
    width: auto;
    margin: 30px 0;
    background-color: ${colors.white};
    width: 140px;
    height: 140px;
    box-shadow: 0 8px 15px 0 rgba(0,0,0,0.1);
    border-radius: 50%;
    background-size: auto 65px;
    background-position: center center;
    background-repeat: no-repeat;
    @media (min-width: 992px) {
      width: 165px;
      height: 165px;
      background-size: auto 80px;
      margin: -25px 0 50px 0;
    }
  }
  .IconCardBanner_title {
    font-size: 28px;
    font-weight: 700;
    letter-spacing: 0;
    line-height: 1;
    color: ${colors.white};
    &::after {
      content: '';
      display: block;
      position: relative;
      width: 75px;
      height: 2px;
      background-color: #C1EE4A;
      margin: 30px 0;
    }
    @media (min-width: 992px) {
      font-size: 23px;
    }
  }
  .IconCardBanner_text {
      p {
        font-size: 21px;
        font-weight: 400;
        line-height: 1.3;
        margin: 0 0 30px 0;
        color: ${colors.white};
      }
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
      }
      li {
        font-size: 21px;
        font-weight: 400;
        line-height: 1.3;
        margin: 0 0 30px 0;
        padding: 0 0 0 20px;
        position: relative;
        color: ${colors.white};
        &::before {
          content: '';
          display: block;
          position: absolute;
          top: 8px;
          left: 0;
          width: 8px;
          height: 8px;
          background-color: ${colors.brand2};
        }
      }
      a {
        font-weight: 700;
        color: #C1EE4A;
      }
    }
`;

function IconCardBanner({ content }) {
  return (
    <div className={styles}>
      <div className="IconCardBanner">
        <div>
          <div className="IconCardBanner_inner">
            <div className="IconCardBanner_cardWrapper">
              {
                get(content, '[0].cards' || []).map(item => {
                  return (
                    <div className="IconCardBanner_card" key={item.title}>
                      <div className="IconCardBanner_content">
                        {
                          get(item, 'icon') &&
                          <div
                            className="IconCardBanner_cardIcon"
                            alt={get(item, 'icon.name')}
                            style={{ backgroundImage: `url(${get(item, 'icon.contentUrl')})` }}
                          />
                         }
                        {
                          get(item, 'title') &&
                          <h4 className="IconCardBanner_title">{get(item, 'title')}</h4>
                        }
                        {
                          get(item, 'text') &&
                          <div className="IconCardBanner_text" dangerouslySetInnerHTML={SanitizeHtml(get(item, 'text'))} />
                        }
                        <ButtonSet buttonSetParent={item} />
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

IconCardBanner.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default IconCardBanner;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/IconCardBanner.section.js